import { useState, useEffect, useCallback } from "react";

/**
 * Returns a debounced value that updates after `delay` ms of no changes.
 * Used for global search to avoid hitting the backend on every keystroke.
 * @param {*} value - The value to debounce
 * @param {number} delay - Delay in ms (default 400)
 * @returns {*} debouncedValue
 */
export function useDebouncedValue(value, delay = 400) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}

export default useDebouncedValue;
